<!-- app.component.html -->
<!-- <app-loader *ngIf="loading$ | async"></app-loader> -->
<router-outlet></router-outlet>
<div *ngIf="!env.production">
  <div class="row">
    <div class="col-6"></div>
    <div class="col-6">
      <strong>Environment:</strong> {{ env.name }} <br>
      <strong>New API:</strong> {{ env.api }} <br>
      <strong>Old API:</strong> {{ oldEnv.api }} <br>
      <strong>DATABASE NAME:</strong> {{ database }} <br>
    </div>
  </div>
</div>

